import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useEffect, useState } from 'react';
import { useEventsManager } from '.';
var SCROLL_EVENT_TYPE = 'block-kit:scroll_event';
export var SCROLL_BLOCK_HASH_PREFIX = '#block-';
export function useScrollEvents(eventsManager) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    event = _useState2[0],
    setEvent = _useState2[1];
  var handleEvent = useCallback(function (event) {
    setEvent(event.data);
  }, []);
  useEffect(function () {
    var subscription = eventsManager.subscribe(SCROLL_EVENT_TYPE, handleEvent);
    return function () {
      return subscription.unsubscribe();
    };
  }, [eventsManager, handleEvent]);
  return event;
}
export function useScrollEvent(containerId) {
  var eventsManager = useEventsManager();
  var event = useScrollEvents(eventsManager);
  if (containerId && containerId === (event === null || event === void 0 ? void 0 : event.containerId)) {
    return event;
  }
  return;
}
export function pushScrollEvent(eventsManager, event) {
  eventsManager.publish(SCROLL_EVENT_TYPE, event);
}
export function usePublishScrollEvent() {
  var eventsManager = useEventsManager();
  var publish = useCallback(function (event) {
    pushScrollEvent(eventsManager, event);
  }, [eventsManager]);
  return publish;
}
export function useClearScrollEvent() {
  var publish = usePublishScrollEvent();
  return function () {
    return publish({
      containerId: ''
    });
  };
}